import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";

import "react-toastify/dist/ReactToastify.css";
import { useStateContext } from "./contexts/ContextProvider";

import AppRoutes from "./components/routes/routes";
import { Auth } from "./pages/Authentication/src/Auth";
import Layout from "./components/layout";
import { Toast } from "primereact/toast";
import { onMessage } from "firebase/messaging";
import { messaging } from "./Firebase/firebase";

const App = () => {
  const toast = useRef(null);
  const { setCurrentColor, setCurrentMode, currentMode } = useStateContext();
  // MOH-560: user lives in state so login can flip the Auth/Layout switch
  // without SignIn's window.location.reload() workaround.
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });
  const [notificationTrigger, setNotificationTrigger] = useState(0);

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  // Set up foreground message listener for push notifications
  useEffect(() => {
    if (!user) {
      return;
    }

    // Check if Firebase messaging is supported
    if (!messaging) {
      console.error("Firebase messaging is not available");
      return;
    }

    try {
      const unsubscribe = onMessage(messaging, (payload) => {
        
        // Show notification using toast
        if (toast.current && payload?.notification) {
          toast.current.show({
            severity: "info",
            summary: payload.notification.title || "New Notification",
            detail: payload.notification.body || "You have a new notification",
            life: 5000,
            style: {
              backgroundColor: '#fba86f',
              color: 'white',
              border: '2px solid #fba86f'
            }
          });
        }

        // Trigger notification list refresh
        setNotificationTrigger(prev => prev + 1);
      });

      // Cleanup function
      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
      };
    } catch (error) {
      console.error("Error setting up foreground message listener:", error);
    }
  }, [user]);

  return (
    <div className={currentMode === "Dark" ? "dark" : ""}>
      <ErrorBoundary>
        <BrowserRouter>
        <Toast ref={toast} />
        {!user ? (
          <Auth onLogin={setUser} />
        ) : (
          <Layout notificationTrigger={notificationTrigger}>
            <AppRoutes />
          </Layout>
        )}
      </BrowserRouter>
    </ErrorBoundary>
    </div>
  );
};

export default App;
